import { useState, useEffect, useContext, Fragment } from "react";
import { useSelector } from "react-redux";

import { DateTime } from "luxon";

import Chip from "@mui/material/Chip";
import { Card, CardContent } from "@mui/material";

import PJPContext from "pages/PJPView/pjp.context";
import "pages/PJPView/pjp.scss";

const BeatsPane = ({ beats }) => {
  return (
    <div className="beats-pane">
      <h5> Beats </h5>
      <div className="beats-list">
        {beats?.map((beat, index) => (
          <Fragment key={"beat" + index}>
            <Card variant="outlined" className="beats-card">
              <CardContent>
                <div> <b> {beat.name} </b></div>
                <br />
                <div className="beats-territories-list">
                  {beat.territories
                    ?.map((t) => t.name.toLowerCase())
                    .join(", ")}
                </div>
              </CardContent>
            </Card>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

const DealersPane = ({ dealers }) => {
  return (
    <div className="dealers-pane">
      <h5> Dealers List </h5>
      <div className="dealers-list">
        {dealers?.map((dealer, index) => (
          <Fragment key={"dealer" + index}>
            <Card variant="outlined" className="dealer-card">
              <CardContent>
                <div className="d-card-header">
                  <span><b>{dealer.name}</b></span>
                  <Chip
                    label={dealer.dealerCategory || "Others"}
                    variant="outlined"
                    sx={{
                      color: "var(--secondary)",
                      borderColor: "var(--secondary)'"
                    }}
                  />
                </div>
                <div className="d-detail">
                  {dealer.dealerCode} | {dealer.phone}
                  <br />
                </div>
              </CardContent>
            </Card>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

const PJPDetail = () => {
  const { plan, officers } = useContext(PJPContext);

  return (
    <div className="pjp-detail-ctr">
      <div className="pjp-header">
        <h4> PJP Detail </h4>
        <div>
          <Chip label={plan?.status} variant="outlined" />
        </div>
      </div>
      <div className="details-pane">
        <div>
          <h5> Matching Dates </h5>
          <div>
            {plan?.matchingDates.length === 0 &&
              "This plan has no matching dates to be reviewed."}

            {plan?.matchingDates
              ?.map((date) => DateTime.fromISO(date).toFormat("dd/MM/yyyy"))
              .join(", ")}
          </div>
          <br />
          <BeatsPane beats={plan?.beats} />
        </div>
        <DealersPane dealers={plan?.dealers} />
      </div>
    </div>
  );
};

export default PJPDetail;
